<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 불량원인 -->
							<th class="col-1">{{ getMessage_('QWCC001453') }}</th>
							<td colspan="3">
								<el-input
									type="textarea"
									:rows="3"
									maxlength="200"
									:show-word-limit="true"
									:value="detailForm.badCausSbc"
									@input="value => onChangeParam({ key: 'badCausSbc', value })"
									:readonly="onChkMdvRplCd"
								/>
							</td>
							<!-- 개선대책 -->
							<th class="col-1">{{ getMessage_('QWCC001443') }}</th>
							<td colspan="5">
								<el-input
									type="textarea"
									:rows="3"
									maxlength="200"
									:show-word-limit="true"
									:value="detailForm.bttmMdvSbc"
									@input="value => onChangeParam({ key: 'bttmMdvSbc', value })"
									:readonly="onChkMdvRplCd"
								/>
							</td>
							<th class="col-1">{{ getMessage_('QWCC000039') }}</th>
							<!-- <td >
								<template v-if="isLoaded">
									<file-download-glims-list
										id="glimsFile"
										ref="glimsFileRef"
										width="100%"
										height="100%"
										:propFileList="this.glimsFileList"
										:isEditable="!onChkMdvRplCd"
										@MultiFile="causFileUpload"
										@onDownload="onDownloadFileGlims"
									>
									</file-download-glims-list>
								</template>
							</td> -->
							<td colspan="3">
								<template v-if="isLoaded">
									<file-upload-list
										id="badCausFile"
										:rows="3"
										width="100%"
										height="100%"
										:propFileList="detailForm.badCausFileDb"
										:isEditable="!onChkMdvRplCd"
										@MultiFile="fileUpload"
										@onDownload="onDownloadFileGlimsHmcErp"
									>
									</file-upload-list>
								</template>
							</td>
							<!-- <td colspan="3">
								<template v-if="isLoaded">
									<file-download-glims-list
										id="badCausFile"
										:rows="3"
										width="100%"
										height="100%"
										:propFileList="detailForm.badCausFileDb"
										@MultiFile="causFileUpload"
										@onDownload="onDownloadFileGlims"
									>
									</file-download-glims-list>
								</template>
							</td> -->
						</tr>
						<tr>
							<!-- 불량원인 파일첨부 -->
							
							<!-- 개선LOT -->
							<th class="col-1">{{ getMessage_('QWCC001454') }}</th>
							<td colspan="3"><el-input v-model="detailForm.bttmLotNo" :readonly="onChkMdvRplCd" /></td>
							<!-- 대책일자 -->
							<th class="col-1">{{ getMessage_('QWCC001444') }}</th>
							<td colspan="3">
								<el-date-picker
									v-model="detailForm.mdvDd"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:disabled="onChkMdvRplCd"
								/>
							</td>
							<!-- 고품처리 -->
							<th class="col-1">{{ getMessage_('QWCC001455') }}</th>
							<td colspan="2">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.rptpPrcsCd"
									:options="getRptpPrcsCdList_"
									:onChange="value => onChangeParam({ key: 'rptpPrcsCd', value })"
									:disabled="onChkMdvRplCd"
								/>
							</td>
							<!-- 작성자 -->
							<th class="col-1">{{ getMessage_('QWCC001382') }}</th>
							<!-- <td><el-input v-model="detailForm.mdvPprrNm" readOnly /></td> -->
							<td colspan="2"><el-input v-model="detailForm.mdvPprrNm" readOnly/></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
// import FileDownloadGlimsList from '@qms/Components/FileDownloadGlimsList.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	async created() {
		this.isLoaded = true;
	},
	components: { FileUploadList},
	computed: {
		...rootComputed,
		...serviceComputed,
		overInspect() {
			return false;
			// 임시저장, 반려, 등록 상태 일 때,
			//return Number(this.detailForm.pgsStCd) >= 30 || this.detailForm.ssId !== this.detailForm.rgnId;
		},
		finAllStep() {
			return Number(this.detailForm.pgsStCd) >= 40;
		},
		// 대책회신 기준으로 활성화, 비활성화
		onChkMdvRplCd() {
			const mdvRplCd = this.detailForm.mdvRplCd; //대책회신
			const pgsStCd = this.detailForm.pgsStCd; // 진행상태
			const partGCd = this.detailForm.partGCd;
			//console.log( mdvRplCd, pgsStCd );
			
			if (mdvRplCd === 'RPL10') {
				//회신필요일경우
				if (pgsStCd !== undefined && pgsStCd === '30'&& partGCd ==='V') {
					// 승인 상태일때
					return false;
				} else {
					return true;
				}
			} else {
				//회신 불필요일경우
				return true;
			}
			// if (pgsStCd !== undefined && pgsStCd === '30' && partGCd ==='V') {
			// 		// 승인 상태일때
			// 		return false;
			// 	} else {
			// 		return true;
			// 	}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async onDownloadFileGlimsHmcErp(file) {
			const { encodeFullName, origFileName,uploadPath } = file;
			await this.fileDownloadGlimsHmcErp_({ origFileName, encodeFullName,uploadPath });
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		
		// causFileUpload(glimsFileList) {
		// 	this.onChangeParam_({ key: 'glimsFileList', value: glimsFileList });
		// },
		// causFileUpload(glimsFileList) {
		// 	this.onChangeParam_({ key: 'badCausFile', value: glimsFileList });
		// },
		fileUpload(saveList) {
			this.onChangeParam_({ key: 'badCausFile', value: saveList });
		},
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		}
	} 
};
</script>

<style></style>
